import { render, staticRenderFns } from "./item-statistic-detail.vue?vue&type=template&id=bd0d8ee4&scoped=true"
import script from "./item-statistic-detail.vue?vue&type=script&lang=js"
export * from "./item-statistic-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0d8ee4",
  null
  
)

export default component.exports